import t from "../../../locales/common.json";

<div class="mbe5 region">
  <container data-width="prose">
    <star
      size=32
      variant
      top="calc(var(--text-2) * 10)"
      left="calc(var(--text-2) * -4.5)"
    />
    <star
      size=16
      top="calc(var(--text-2) * 12)"
      left="calc(var(--text-2) * -3)"
    />
    <star
      size=16
      bottom="calc(var(--text-2) * 6)"
      right="calc(var(--text-2) * -4)"
    />
    <heading-1 class="text-center font-bold mbe5">
      ${t.cc.About.header}
    </heading-1>
    <div class="text1 font-semibold mbe2">${t.cc.About.description}</div>
    <u-list class="leading2">
      <for|service| of=t.cc.About.services>
        <li>${service}</li>
      </for>
    </u-list>
  </container>

  <div class="pb4 bg-accent2 text-light mb4">
    <div class="wrapper" data-width="prose">
      <heading-2 class="text3 mbe2 text-center">
        ${t.cc.About.why.header}
      </heading-2>
      <p>${t.cc.About.why.description}</p>
    </div>
  </div>

  <container>
    <enclosed-section data-width="prose" class="p3 relative">
      <star size=16 left="var(--space-3)" top="var(--space-3)"/>
      <star
        size=32
        left="calc(var(--space-3) + var(--space-1))"
        top="calc(var(--space-3) + var(--space--2))"
      />
      <heading-2 class="text-accent text-center font-bold text3 mbe1">
        ${t.cc.About.history.header}
      </heading-2>
      <star size=24 right="3%" top="15%"/>

      <p>${t.cc.About.history.description}</p>
    </enclosed-section>
  </container>
</div>
